var _path, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNativeSoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 154,
    viewBox: "0 0 135 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5014 48.1063C16.0821 53.3299 19.4986 57.6447 20.7865 59.0839C20.9195 59.2637 20.7837 59.5311 20.6053 59.4406C18.6835 59.2496 13.184 59.0361 9.75794 63.3526C9.57821 63.4856 9.31074 63.3498 9.31214 63.1262C10.7767 57.8134 7.36023 53.4986 6.07234 52.0594C5.80486 51.9235 5.94071 51.6561 6.25347 51.7028C8.17532 51.8937 13.6748 52.1072 17.0556 47.8799C17.2806 47.6577 17.5481 47.7935 17.5014 48.1063V48.1063Z",
    stroke: "#108DA0",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_444_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0974 137.805L11.4632 48.5333C8.82715 41.5366 15.3775 34.5629 22.5254 36.7561L100.838 60.7853C106.642 62.5662 109.054 69.4654 105.624 74.4746L60.9451 139.717C56.8327 145.722 47.6635 144.616 45.0974 137.805Z",
    fill: "url(#paint0_linear_444_163)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2058 76.25C49.0842 77.1892 50.6942 78.6075 51.8633 80.3708C52.5342 81.3675 52.5342 82.6517 51.8633 83.6483C50.6942 85.3925 49.0842 86.8108 47.2058 87.75",
    stroke: "#108DA0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8333 83.9933V87.75C37.8333 97.3333 41.6667 101.167 51.25 101.167H62.75C72.3333 101.167 76.1667 97.3333 76.1667 87.75V76.25C76.1667 66.6666 72.3333 62.8333 62.75 62.8333H51.25C41.6667 62.8333 37.8333 66.6666 37.8333 76.25M58.9167 87.75H66.5833",
    stroke: "#108DA0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_444_163",
    x: 0.867584,
    y: 26.3453,
    width: 116.335,
    height: 127.288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_444_163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_163",
    x1: 46.6425,
    y1: 15.6893,
    x2: 92.8291,
    y2: 138.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4FF99",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeSoftware);
export default __webpack_public_path__ + "static/media/native_software.d03e3039060bc7b9a8acf6bf70522a20.svg";
export { ForwardRef as ReactComponent };